import React from 'react';
import { FavoriteDB } from 'src/data/datatypes';
import ConfirmPopup from './ConfirmPopup';
import FavoriteListItemRemoveButton from '../atoms/FavoriteListItemRemoveButton';
import FavoriteListItemViewButton from '../atoms/FavoriteListItemViewButton';

type Properties = {
    item: FavoriteDB;
    viewItem: () => void;
    removeItem: () => void;
};

const FavoriteListItem = (props: Properties) => {
    const [showDeleteDialog, setShowDeleteDialog] = React.useState<boolean>(false);

    const removeConfirmed = () => {
        setShowDeleteDialog(false);
        props.removeItem();
    };

    const removeDismissed = () => {
        setShowDeleteDialog(false);
    };

    return (
        <div className="favorite-listitem favorite-listitem-session">
            <div className="favorite-listitem-menu">
                <div className="favorite-listitem-desc">
                    {props.item.title}
                </div>
                <div className="favorite-listitem-buttons">
                    <FavoriteListItemRemoveButton onClick={() => setShowDeleteDialog(true)} />
                    <FavoriteListItemViewButton onClick={props.viewItem} />
                </div>
            </div>
            {showDeleteDialog &&
                <ConfirmPopup
                    title="Favorit löschen"
                    text={`Den Favorit "${props.item.title}" löschen?`}
                    confirmLabel="Löschen"
                    dismissLabel="Abbrechen"
                    onConfirmClicked={removeConfirmed}
                    onDismissClicked={removeDismissed}
                />
            }
        </div>
    );
};

export default FavoriteListItem;
